import { Category } from '@app/components/ui/category-select/CategorySelect';
import { Device, Tag } from '@app/services/types';
import { isSensor } from '../devices';
import plugCategories from './plug-categories';
import sensorCategories from './sensor-categories';

export const getTagCategories = (device: Device): Category<Tag>[] =>
  isSensor(device) ? sensorCategories : plugCategories;
